import Homepage from '../components/dashboard_components/Homepage.vue';
import AboutUsPage from '../components/dashboard_components/AboutUsPage.vue';
import ContactPageNew from '../components/dashboard_components/ContactPageNew.vue';
import AccountDeletion from '../components/dashboard_components/AccountDelete.vue';
import MerchantForm from '../components/reuseable_components/MerchantForm.vue';
import MerchantExtended from '../components/reuseable_components/MerchantExtended.vue';
import MerchantAgreement from '../components/reuseable_components/MerchantAgreement.vue';
import MerchantDashboard from '../components/reuseable_components/merchant_dashboard/MerchantDashboard.vue';
import MerchantUserDetails from '../components/reuseable_components/merchant_dashboard/MerchantUserDetails.vue';
import MerchantTransaction from '../components/reuseable_components/merchant_dashboard/MerchantTransaction.vue';

import SuccessTransaction from '../components/reuseable_components/merchant_dashboard/SuccessTransaction.vue';
import FailedTransaction from '../components/reuseable_components/merchant_dashboard/FailedTransaction.vue';

import MerchantWithdraw from '../components/reuseable_components/merchant_dashboard/MerchantWithdraw.vue';
import MerchantStatement from '../components/reuseable_components/merchant_dashboard/MerchantStatement.vue';
import MerchantBank from '../components/reuseable_components/merchant_dashboard/MerchantBank.vue';
import MerchantQrCode from '../components/reuseable_components/merchant_dashboard/MerchantQrCode.vue';
import MerchantSettingsKey from '../components/reuseable_components/merchant_dashboard/MerchantSettings.vue';
import MerchantSettingsUrl from '../components/reuseable_components/merchant_dashboard/MerchantSettingsUrl.vue';
import MerchantDocuments from '../components/reuseable_components/merchant_dashboard/MerchantDocuments.vue';
import MerchantKyc from '../components/reuseable_components/merchant_dashboard/MerchantKyc.vue';

//Payment Methods
import MerchantPaymentRequest from '../components/reuseable_components/payment_method/MerchantPaymentRequest.vue';
import MerchantPayment from '../components/reuseable_components/payment_method/MerchantPayment.vue';
import MerchantPaymentLogin from '../components/reuseable_components/payment_method/PaymentLogin.vue';
import MerchantPaymentConfirm from '../components/reuseable_components/payment_method/PaymentConfirm.vue';

import PrivacyPolicyNew from '../components/reuseable_components/PrivacyPolicyNew.vue';
import TermAndCondition from '../components/dashboard_components/TermAndCondition.vue';
import CustomerCare from '../components/dashboard_components/CustomerCare.vue';
import FaqNew from '../components/dashboard_components/FaqNew.vue';
import OfferPage from '../components/dashboard_components/OfferPage.vue';
import Loginpage from '../components/login_components/Loginpage.vue';
import RegisterConfirmation from '../components/dashboard_components/RegisterConfirmationForm.vue';
import ForgotPassword from '../components/dashboard_components/ForgotPassword.vue';
import AdminDashboard from '../components/dashboard_components/AdminDashboard.vue';
import LoadFund from '../components/dashboard_components/LoadFund.vue';
import LoadPayu from '../components/dashboard_components/LoadPayu.vue';
import PayuSuccess from '../components/dashboard_components/PayuSuccess.vue';
import PayuFail from '../components/dashboard_components/PayuFail.vue';
import PayFund from '../components/dashboard_components/PayFund.vue';
import LoadCards from '../components/dashboard_components/LoadCards.vue';
import TransferFund from '../components/dashboard_components/TransferFund.vue';
import RequestFund from '../components/dashboard_components/RequestFund.vue';
import WithdrawFund from '../components/dashboard_components/WithdrawFund.vue';
import Profile from '../components/dashboard_components/Profile.vue';
import Transactions from '../components/dashboard_components/Transactions.vue';
import UserStatement from '../components/dashboard_components/UserStatement.vue';
import RemoveBank from '../components/dashboard_components/RemoveBank.vue';
import ChangePassword from '../components/dashboard_components/ChangePassword.vue';
import Merchant from '../components/dashboard_components/Merchant.vue';
import EPay from '../components/dashboard_components/EPay.vue';
import Help from '../components/dashboard_components/Help.vue';
import Security from '../components/dashboard_components/Security.vue';
import Bank from '../components/dashboard_components/Bank.vue';
import Kyc from '../components/dashboard_components/Kyc.vue';
import QrCode from '../components/dashboard_components/QrCode.vue';
import Mpin from '../components/dashboard_components/Mpin.vue';
import Account from '../components/dashboard_components/Account.vue';
import FeedBack from '../components/dashboard_components/FeedBack.vue';
import TermsOfUse from '../components/dashboard_components/TermsOfUse.vue';
import VerifyUserEmail from '../components/dashboard_components/VerifyUserEmail.vue';
import UserRegister from '../components/login_components/UserRegister.vue';
import ForgetPassword from '../components/login_components/ForgetPassword.vue';
import PageNotFound from '../components/reuseable_components/PageNotFound.vue';

//icons
import Vue from 'vue'
import { BModal } from 'bootstrap-vue'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('b-modal', BModal)

//Static Pages 

import FAQ from '../components/dashboard_components/FAQ.vue';
import Logout from '../components/dashboard_components/Logout.vue';

export default[
  {path: '/', name: 'home', component: Homepage},
  {path: '/verify-user-email', name: 'VerifyUserEmail', component: VerifyUserEmail},
  {path: '/contact', name: 'contactpagenew', component: ContactPageNew},
  {path: '/account-deletion', name: 'accountdelete', component: AccountDeletion},
  {path: '/merchant', name: 'Merchant', component: MerchantForm},
  {path: '/merchant-extended', name: 'merchant-extended', component: MerchantExtended},
  {path: '/merchant-agreement', name: 'merchant-agreement', component: MerchantAgreement},
  {path: '/merchant-dashboard', name: 'merchant-dashboard', component: MerchantDashboard},
  {path: '/merchant-user-details', name: 'merchant-user-details', component: MerchantUserDetails},
  {path: '/merchant-transaction/:transactionid', name: 'merchant-transaction', component: MerchantTransaction},
  {path: '/merchant-success-transaction', name: 'merchant-success-transaction', component: SuccessTransaction},
  {path: '/merchant-failed-transaction', name: 'merchant-failed-transaction', component: FailedTransaction},
  {path: '/merchant-withdraw', name: 'merchant-withdraw', component: MerchantWithdraw},
  {path: '/merchant-statement', name: 'merchant-statement', component: MerchantStatement},
  {path: '/merchant-bank', name: 'merchant-bank', component: MerchantBank},
  {path: '/merchant-qr', name: 'merchant-qr', component: MerchantQrCode},
  {path: '/merchant-settings-key', name: 'merchant-settings-key', component: MerchantSettingsKey},
  {path: '/merchant-settings-url', name: 'merchant-settings-url', component: MerchantSettingsUrl},
  {path: '/merchant-documents', name: 'merchant-documents', component: MerchantDocuments},
  {path: '/merchant-kyc', name: 'merchant-kyc', component: MerchantKyc},
  //Payment Method
  {path: '/merchant/payment', name: 'merchant-payment-request', component: MerchantPaymentRequest},
  {path: '/merchant/payment/initiate/:transactionid', name: 'merchant-payment', component: MerchantPayment},
  {path: '/merchant/payment/login/:transactionid', name: 'payment-login-form', component: MerchantPaymentLogin},
  {path: '/merchant/payment/confirm/:transactionid', name: 'payment-confirm', component: MerchantPaymentConfirm},




  {path: '/about-us', name: 'AboutUsPage', component: AboutUsPage},
  {path: '/privacy-policy', name: 'pricacyPolicy', component: PrivacyPolicyNew},
  {path: '/term-condition', name: 'termAndCondition', component: TermAndCondition},
  {path: '/customer-care', name: 'customerCare', component: CustomerCare},
  {path: '/faqs', name: 'faqNew', component: FaqNew},
  {path: '/offer', name: 'OfferPage', component: OfferPage},
  {path: '/login', name: 'login', component: Loginpage},
  {path: '/register', redirect: {name: 'UserRegister'}},
  {path: '/activateaccount', name: 'activateaccount', component: RegisterConfirmation},
  {path: '/forgotpassword', name: 'forgotpassword', component: ForgotPassword},
  {path: '/logout', name: 'logout', component: Logout},
  {path: '/app', name: 'app', component: AdminDashboard},
  {path: '/app/load', name: 'load', component: LoadFund},
  {path: '/app/loadpayu', name: 'loadpayu', component: LoadPayu},
  {path: '/app/payu/success', name: 'payusuccess', component: PayuSuccess},
  {path: '/app/payu/fail', name: 'payufail', component: PayuFail},
  {path: '/app/pay', name: 'pay', component: PayFund},
  {path: '/app/loadcard', name: 'loadcard', component: LoadCards},
  {path: '/app/transfer', name: 'transfer', component: TransferFund},
  {path: '/app/request', name: 'request', component: RequestFund},
  {path: '/app/withdraw', name: 'withdraw', component: WithdrawFund},
  {path: '/app/profile', name: 'profile', component: Profile},
  {path: '/app/security', name: 'Security', component: Security},
  {path: '/app/bank', name: 'Bank', component: Bank},
  {path: '/app/kyc', name: 'Kyc', component: Kyc},
  {path: '/app/qr-code', name: 'QrCode', component: QrCode},
  {path: '/app/mpin', name: 'Mpin', component: Mpin},
  {path: '/app/account', name: 'Account', component: Account},
  {path: '/app/transactions', name: 'transactions', component: Transactions},
  {path: '/app/statement', name: 'user-statement', component: UserStatement},
  {path: '/app/removebank', name: 'removebank', component: RemoveBank},
  {path: '/app/changepassword', name: 'changepassword', component: ChangePassword},
  {path: '/app/merchant', name: 'merchant', component: Merchant},
  {path: '/app/epay/:amount/:wallet', name: 'epay', component: EPay},
  {path: '/app/help', name: 'Help', component: Help},
  {path: '/app/feedback', name: 'FeedBack', component: FeedBack},
  {path: '/app/termsofuse', name: 'TermsOfUSe', component: TermsOfUse},
  {path: '/app/faq', name: 'FAQ', component: FAQ},
  // ---------------------------------------------------------------------
  // REGISTRATION - one flow only.
  //
  // UserRegister posts to auth/register, verifies the emailed code through
  // auth/verify-otp, and that second call is what creates the account.
  //
  // The old phone-first chain (/number -> /pin -> /basicdetail -> /contactinfo
  // -> /accountprofile -> /transactionpin) posted to the retired `registerotp`
  // endpoints and is gone. Its paths REDIRECT rather than 404, so a bookmark,
  // an old email link or any affordance missed in the sweep still lands on the
  // current flow instead of a dead screen.
  // ---------------------------------------------------------------------
  {path: '/user-register', name: 'UserRegister', component: UserRegister},
  {path: '/number', redirect: {name: 'UserRegister'}},
  {path: '/pin', redirect: {name: 'UserRegister'}},
  {path: '/accountprofile', redirect: {name: 'UserRegister'}},
  {path: '/contactinfo', redirect: {name: 'UserRegister'}},
  {path: '/basicdetail', redirect: {name: 'UserRegister'}},
  {path: '/transactionpin', redirect: {name: 'UserRegister'}},
  {path: '/forgetpassword', name: 'ForgetPassword', component: ForgetPassword},
  // /recoverpin belonged to the old chain's transaction-PIN step and nothing links
  // to it. It is NOT redirected to registration - "recover a PIN" is not "create an
  // account". MPIN now has its own flow under Settings.
  // /newpassword was step 2 of recovery as its own screen. It posted `otp` and
  // `new_password`, neither of which users/resetpassword reads, so it could never have
  // worked. The whole flow now lives in ForgetPassword; the path redirects so any old
  // link still lands somewhere useful.
  {path: '/newpassword', redirect: {name: 'ForgetPassword'}},

  //Static Pages
  // {path: 'app/about', name: 'about', component: About},
  // {path: 'app/privacypolicy', name: 'privacypolicy', component: PrivacyPolicy},
  // {path: 'app/terms', name: 'terms', component: TermsOfService},
  // {path: 'app/contact', name: 'Help', component: Help},
  {path: '*', name: 'PageNotFound', component: PageNotFound},

]
